/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  createPeriodColumn,
  createTargetColumn,
  createTitleColumn,
} from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PublishStep/PublishStep.tableColumns';
import { BannerPromotionPublicationTableData } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PublishStep/PublishStep.types';
import { STable } from 'pages/EstimatePage/EstimatePage.styled';
import { GetTitle } from 'pages/EstimatePage/TableSection/tableComponents';
import { Flex, Text, WithTooltip } from 'UI';

export const TableBanner = ({ data }: { data: BannerPromotionPublicationTableData }) => {
  const { t } = useTranslation();
  const getDataColumns = () => {
    return [
      createTitleColumn(t, { key: 'title' }),
      createPeriodColumn(t, { key: 'period' }),
      {
        title: GetTitle(t('backoffice.promotion.publication_preview.commercial_family', 'Commercial family')),
        dataIndex: 'commercialFamilyCodes',
        key: 'commercialFamilyCodes',
        render: function renderCommercialFamily(commercialFamilyCodes: string) {
          return (
            <Flex maxWidth={150} justify={'center'} align={'center'} data-cy={'commercial-family-value'}>
              <WithTooltip title={commercialFamilyCodes}>
                <Text type={'text'} ellipsis={true}>
                  {commercialFamilyCodes}
                </Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      {
        title: GetTitle(t('backoffice.promotion.publication_preview.references', 'References')),
        dataIndex: 'referencesTimeLimited',
        key: 'referencesTimeLimited',
        render: function renderReferences(references: string) {
          return (
            <Flex maxWidth={150} justify={'center'} align={'center'} data-cy={'references-value'}>
              <WithTooltip title={references}>
                <Text type={'text'}>{references}</Text>
              </WithTooltip>
            </Flex>
          );
        },
      },
      createTargetColumn(t, { key: 'targetedAudience' }),
    ];
  };
  if (!data) {
    return null;
  }
  return (
    <STable
      key={'promotions_flash_time_limited_table'}
      dataSource={[data]}
      columns={getDataColumns()}
      pagination={false}
    />
  );
};
